import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectOrganizationUnitsListItems } from "../../../../../../redux/organizationUnits/selector";
import { organizationUnits } from "../../../../../../redux/organizationUnits/action";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";


const ManagementOrganizationUnits = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const organizationUnitsItems = useSelector(selectOrganizationUnitsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'OrganizationUnitInfo.Name', headerName: 'Name'},
          { field: 'OrganizationUnitInfo.Email', headerName: 'Email' },
          { field: 'OrganizationUnitInfo.PhoneNumber', headerName: 'PhoneNumber' },
          { field: 'OrganizationUnitInfo.CountryCode', headerName: 'Country Code' },
          { field: 'OrganizationUnitInfo.CurrencyCode', headerName: 'Currency Code' },
          { field: 'OrganizationUnitInfo.OrganizationUnitGST', headerName: 'OrganizationUnit GST' },
          { field: 'OrganizationUnitInfo.OrganizationUnitTIN', headerName: 'OrganizationUnit TIN' },
          { field: 'OrganizationUnitInfo.OrganizationUnitVat', headerName: 'OrganizationUnit Vat' },
          { field: 'OrganizationUnitInfo.SslEnabled', headerName: 'SslEnabled', cellRenderer: 'yesNoRenderer' },
          { field: 'OrganizationUnitInfo.IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
      const fetchOrganizationUnits=()=>{

        dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchOrganizationUnits()
	}, [pageData])
  const additionButtons: any = [
    {
      name: 'Add OrganizationUnits',
      callback: () => handleAdd(),
    }
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    
    navigate(`${data?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(organizationUnits.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/delete`,
      entity: 'organizationUnits',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{
       "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",}
      }));
  });
  }  
	return (
    <>
    {organizationUnitsItems?.isLoading ? 
    <PageLoader />
:     
		<Table columnData={columnDefs} rowData={organizationUnitsItems?.result?.items} setPageData={setPageData}
    paginationData={organizationUnitsItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Organization Units" />
  }
  </> 
     
	);
};

export default ManagementOrganizationUnits;


